import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { Coleccionista, ColeccionistasResponse, DataColeccionista } from 'app/models/coleccionitas.model';
import { RegistroBienCulturalDTO } from 'app/models/registro-bien-cultural.model';
import { RegistroBienCulturalResponse } from 'app/models/response-registro-bien-cultural.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class RegistroBienCulturalService {
    coleccionistas: BehaviorSubject<DataColeccionista[]> = new BehaviorSubject([])
    private _seccion_uuid: BehaviorSubject<number> = new BehaviorSubject(0)

    get coleccionistas$(){
        return this.coleccionistas.asObservable()
    }

    set seccion_uuid(seccion_id:number){
        this._seccion_uuid.next(seccion_id)
    }

    get seccion_uuid_value(): number{
        return  this._seccion_uuid.getValue();
    }

    constructor(private apiService:ApiService) { }

    getColeccionistas(params?:any){
        const url= `/coleccionista`
        return new Promise((resolve, reject)=>{
                    this.apiService.GetMethod(url, params, 'Error al obtener listado de coleccionistas.')
                        .subscribe((response: ColeccionistasResponse) => {
                            this.coleccionistas.next(response.data)
                            resolve(response)  
                        }, error => {
                            reject(true)
                        })
                })
    }

    registroBienCultural(body: RegistroBienCulturalDTO){
        const url= `/bien_cultural/paso1` 
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body, {}, 'Error al guardar Bien cultural.')
                .subscribe((response: RegistroBienCulturalResponse) => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        }) 
    }
    
    
}